import { useCompanyMutations } from "@app/entities/company/mutations";
import { useCompany } from "@app/providers/CompanyContextProvider";
import Form from "antd/lib/form";
import { useEffect, useMemo } from "react";

export const useNotificationsLoader = () => {
  const { selectedCompany } = useCompany();
  const [notificationsForm] = Form.useForm();

  useEffect(() => {
    if (!selectedCompany) return;
    const { lowBalanceEmail, lowBalanceThreshold, staleReportsEmail } =
      selectedCompany;
    notificationsForm.setFieldsValue({
      lowBalanceEmail,
      lowBalanceThreshold: (lowBalanceThreshold ?? 0) / 100,
      staleReportsEmail,
    });
  }, [selectedCompany]);

  const formValues = Form.useWatch([], notificationsForm);

  const hasChanges = useMemo(() => {
    if (!selectedCompany || !formValues) return false;
    const { lowBalanceEmail, lowBalanceThreshold, staleReportsEmail } =
      formValues;
    return (
      (lowBalanceEmail || null) !== (selectedCompany.lowBalanceEmail || null) ||
      (lowBalanceThreshold ?? 0) * 100 !==
        (selectedCompany.lowBalanceThreshold ?? 0) ||
      (staleReportsEmail || null) !==
        (selectedCompany.staleReportsEmail || null)
    );
  }, [formValues, selectedCompany]);

  const { updateNotifications, isMutationPending } = useCompanyMutations();

  const handleUpdateNotifications = () => {
    const { lowBalanceEmail, staleReportsEmail, lowBalanceThreshold } =
      notificationsForm.getFieldsValue();
    const notificationsData = {
      lowBalanceEmail,
      staleReportsEmail,
      lowBalanceThreshold: lowBalanceThreshold * 100,
    };
    updateNotifications(notificationsData);
  };

  const isLoading = isMutationPending;

  return {
    notificationsForm,
    handleUpdateNotifications,
    hasChanges,
    isLoading,
  };
};
